import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import LeafletInternalPopup from './LeafletInternalPopup';

class LeafletPopup extends Component {
    componentDidUpdate() {
        const { children } = this.props;
        if (this.popupContainer) {
            ReactDOM.render(children, this.popupContainer);
        }
    }

    onPopupInitialize = container => {
        this.popupContainer = container;
        const { children } = this.props;
        ReactDOM.render(children, container);
    };

    render() {
        const { children, ...others } = this.props;
        return (
            <LeafletInternalPopup
                {...others}
                onPopupInitialize={this.onPopupInitialize}
                children={children}
            />
        );
    }
}

export default LeafletPopup;
